/**
 * ClinicalHUD3 Live one-time attestation screen.
 * Wording is a placeholder until the owner's attorney supplies it.
 */
import { useState } from "react";
import {
  Alert,
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { CLINICAL_HUD3_ATTESTATION_STATEMENT_TEXT } from "../clinicalHud3Constants";
import { recordClinicalHud3LiveAttestation } from "../clinicalHud3LiveCallables";

export default function ClinicalHud3LiveAttestationScreen() {
  const [agreed, setAgreed] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleContinue = async () => {
    if (!agreed || submitting) return;
    setSubmitting(true);
    setError(null);
    try {
      await recordClinicalHud3LiveAttestation();
      // Hook snapshot of clinicalHud3LiveAttestation/{uid} refreshes the gate.
    } catch (err) {
      setError(
        err?.message || "Could not record your attestation. Please try again.",
      );
      setSubmitting(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 640, mx: "auto", py: 6, px: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        ClinicalHUD3 Live attestation
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        {CLINICAL_HUD3_ATTESTATION_STATEMENT_TEXT}
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={agreed}
            onChange={(event) => setAgreed(event.target.checked)}
            disabled={submitting}
          />
        }
        label="I have read and agree to this statement"
        sx={{ mb: 2, display: "flex", alignItems: "flex-start" }}
      />
      {error ? (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      ) : null}
      <LoadingButton
        loading={submitting}
        disabled={!agreed}
        onClick={handleContinue}
      >
        Continue
      </LoadingButton>
    </Box>
  );
}
